// extracted by mini-css-extract-plugin
export default {"Base":"TrackWork_Base__MLNez","Header":"TrackWork_Header__5jFxq","Title":"TrackWork_Title__aQSlP","More":"TrackWork_More__MfLVH","BoxShadow":"TrackWork_BoxShadow__+P3wf"};